import * as React from 'react';
import { Button, Icon } from '@tlx/atlas';
import { StatusIcon } from '@Page/SalaryTaxCard/component/StatusBar/StatusCard/StatusIcon';
import classNames from 'classnames';
import { CardVariant } from '@Page/SalaryTaxCard/component/StatusBar/StatusBar';
import { useIntl } from 'react-intl';

export type StatusCardProps = {
    cardStyle?: CardStyle;
    children: React.ReactNode;
    closeHandler?: () => void;
};
interface CardStyle {
    borderColor: string;
    backgroundColor: string;
    color: string;
    bg: string;
    icon: CardVariant | string;
}

export function StatusCard({ cardStyle, children, closeHandler }: StatusCardProps) {
    const intl = useIntl();

    if (!cardStyle || !children) {
        return null;
    }

    return (
        <div className={classNames('taxcard__statusCard', cardStyle.backgroundColor, cardStyle.borderColor)}>
            <StatusIcon {...cardStyle} />
            <div className="atl-flex atl-items-center">{children}</div>
            {closeHandler !== undefined && (
                <Button
                    variant="icon"
                    aria-label={intl.formatMessage({ id: 'button_close' })}
                    className="taxcard__statusCard_close"
                    onClick={closeHandler}
                    data-testid="close-button"
                >
                    <Icon>close</Icon>
                </Button>
            )}
        </div>
    );
}
